import React, { createContext } from 'react';

import { defaultSettings } from 'config';

import useLocalStorage from 'hooks/useLocalStorage';

// ----------------------------------------------------------------------

const initialState = {
    ...defaultSettings,
    onChangeMode: () => {},
    onToggleMode: () => {},
};

const SettingsContext = createContext(initialState);

// ----------------------------------------------------------------------

const SettingsProvider: React.FunctionComponent = ({ children }) => {
    const [settings, setSettings] = useLocalStorage('settings', {
        themeMode: initialState.themeMode,
    });

    const onChangeMode = event => {
        setSettings({
            ...settings,
            themeMode: event.target.value,
        });
    };

    const onToggleMode = () => {
        setSettings({
            ...settings,
            themeMode: settings.themeMode === 'light' ? 'dark' : 'light',
        });
    };

    return (
        <SettingsContext.Provider
            value={{
                ...settings,
                // Mode
                onChangeMode,
                onToggleMode,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
};

export { SettingsProvider, SettingsContext };
